'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.dayAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/dayAfter.js
// module id = 152
// module chunks = 0